import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Tag } from "@gemini/ui";
import { CheckFilledCircleIcon, FireFilledIcon, PaperPlaneFilledIcon, StarFilledIcon, } from "@gemini/icons";
import { useTags } from "@/hooks";
import { useI18n } from "@/shared/hooks";
import { IS_SERVER } from "@/constants";
import { HdExclusiveTag } from "./HdExclusiveTag";
export const Tags = () => {
    const { t } = useI18n();
    const { isNew, isSeen, isContacted, isExclusive, isHdExclusive } = useTags();
    // Part of tags are based upon localStorage data, so we don't render them on the server to avoid flickering effect
    if (IS_SERVER)
        return null;
    return (_jsxs(_Fragment, { children: [isNew && (_jsx(Tag, { variant: "primary", icon: FireFilledIcon, marginRight: "spacing.8", children: t("tags.new.label") })), isSeen && (_jsx(Tag, { variant: "light", icon: CheckFilledCircleIcon, marginRight: "spacing.8", children: t("tags.viewed.label") })), isContacted ? (_jsx(Tag, { variant: "light", icon: PaperPlaneFilledIcon, marginRight: "spacing.8", children: t("tags.contacted.label") })) : (isHdExclusive && _jsx(HdExclusiveTag, {})), isExclusive && (_jsx(Tag, { variant: "light", icon: StarFilledIcon, marginRight: "spacing.8", children: t("tags.exclusivity.label") }))] }));
};
